"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.graphqlMutation = void 0;
var react_hooks_1 = require("@apollo/react-hooks");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var React = __importStar(require("react"));
var ThreeDSecureContext_1 = __importDefault(require("../ThreeDSecureContext"));
exports.graphqlMutation = graphql_tag_1["default"](templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation threeDSecureVerify(\n    $status: String!\n    $cartId: String!\n    $orderCartUrlCode: String!\n    $orderUuid: String!\n  ) {\n    threeDSecureVerify(\n      status: $status\n      cartId: $cartId\n      orderCartUrlCode: $orderCartUrlCode\n      orderUuid: $orderUuid\n    )\n  }\n"], ["\n  mutation threeDSecureVerify(\n    $status: String!\n    $cartId: String!\n    $orderCartUrlCode: String!\n    $orderUuid: String!\n  ) {\n    threeDSecureVerify(\n      status: $status\n      cartId: $cartId\n      orderCartUrlCode: $orderCartUrlCode\n      orderUuid: $orderUuid\n    )\n  }\n"])));
var useThreeDSecureVerifyMutation = function () {
    var _a = React.useContext(ThreeDSecureContext_1["default"]), orderCart = _a.orderCart, orderUuid = _a.orderUuid, cartId = _a.cartId;
    var _b = __read(react_hooks_1.useMutation(exports.graphqlMutation), 2), verifyStatus = _b[0], _c = _b[1], data = _c.data, loading = _c.loading, error = _c.error;
    var threeDSecureVerify = function (status) {
        return verifyStatus({
            variables: {
                status: status,
                cartId: cartId,
                orderUuid: orderUuid,
                orderCartUrlCode: orderCart.urlCode
            }
        });
    };
    return {
        threeDSecureVerify: threeDSecureVerify,
        loading: loading,
        error: error,
        data: data
    };
};
exports["default"] = useThreeDSecureVerifyMutation;
var templateObject_1;
